module.exports = __webpack_public_path__ + "static/media/5DPO23.7e7a2b4e.jpg";